import React from 'react';

const Contact = () => {
  return (
    <section id="contato" className="py-16 bg-neutral-lightest">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-sans font-bold mb-2 text-primary">Entre em Contato</h2>
          <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tire suas dúvidas e saiba mais sobre a mentoria médica e o curso de implantes
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;

